import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../styles/Depoimentos.css";

const depoimentosData = [
  {
    id: 1,
    nome: "Ana Souza",
    texto: "O sistema transformou totalmente a forma como gerencio meus dados. Simples, rápido e intuitivo!",
    foto: "https://i.pravatar.cc/100?img=1",
  },
  {
    id: 2,
    nome: "Carlos Lima",
    texto: "Excelente plataforma! Me surpreendeu pela facilidade e pela eficiência dos recursos.",
    foto: "https://i.pravatar.cc/100?img=2",
  },
  {
    id: 3,
    nome: "Marcos Costa",
    texto: "A equipe é super atenciosa e o sistema é impecável. Recomendo de olhos fechados!",
    foto: "https://i.pravatar.cc/100?img=3",
  },
];

export default function Depoimentos() {
  const [index, setIndex] = useState(0);

  const anterior = () => {
    setIndex((prev) => (prev === 0 ? depoimentosData.length - 1 : prev - 1));
  };

  const proximo = () => {
    setIndex((prev) => (prev === depoimentosData.length - 1 ? 0 : prev + 1));
  };

  const { nome, texto, foto } = depoimentosData[index];

  return (
    <section className="depoimentos-section">
      <h2 className="depoimentos-titulo">Depoimentos</h2>

      <div className="depoimentos-container">
        <button className="arrow-btn" onClick={anterior}>
          <ChevronLeft size={28} />
        </button>

        <div className="depoimento-card">
          <img src={foto} alt={nome} className="depoimento-foto" />
          <p className="depoimento-texto">“{texto}”</p>
          <span className="depoimento-nome">— {nome}</span>
        </div>

        <button className="arrow-btn" onClick={proximo}>
          <ChevronRight size={28} />
        </button>
      </div>
    </section>
  );
}
